import { useMediaQuery } from "@material-ui/core";
import React from "react";
import { Filter as RaFilter, ReferenceInput, SelectInput } from "react-admin";
import SearchInput from "../components/inputs/SearchInput";
import { useFiltersStyles } from "../components/lists/useStyles";
import statuses from "./statuses";

const Filters = ({ permissions, ...props }) => {
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	const classes = useFiltersStyles();
	return (
		<RaFilter {...props} classes={classes}>
			<SearchInput source="q" alwaysOn fullWidth variant="outlined" />
			<SelectInput
				source="status"
				choices={statuses}
				alwaysOn={!sm}
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
				variant="outlined"
			/>
			{permissions && permissions("admin") && (
				<ReferenceInput
					source="role_id"
					reference="roles"
					alwaysOn={!sm}
					fullWidth
					allowEmpty
					emptyText="ra.action.all"
					variant="outlined"
				>
					<SelectInput optionText="name" />
				</ReferenceInput>
			)}
			<SelectInput
				source="has_children"
				alwaysOn={!sm}
				fullWidth
				variant="outlined"
				choices={[
					{ id: true, name: "ra.action.yes" },
					{ id: false, name: "ra.action.no" },
				]}
				allowEmpty
				emptyText="ra.action.all"
			/>
		</RaFilter>
	);
};
export default Filters;
